import { MEDIA_TYPE } from "../../const";
import { Language } from "../const";

export enum VIDEO_TYPE {
  HKCTC_REPORT = "HKCTC_REPORT",
  TC_SERVICES = "TC_SERVICES",
  CAREER_DEVELOPMENT = "CAREER_DEVELOPMENT",
  MANPOWER_DEVELOPMENT = "MANPOWER_DEVELOPMENT",
}

export type VideoListData = {
  title: string;
  url: string;
  platform: "FILE" | "YOUTUBE";
  cate: VIDEO_TYPE[];
  type: MEDIA_TYPE;
};
export const videoListLanguageMap: Record<Language, string> = {
  [Language.EN]: "/data/en/news-and-videos/videos-en.json",
  [Language.TC]: "/data/tc/news-and-videos/videos-tc.json",
  [Language.SC]: "/data/sc/news-and-videos/videos-sc.json",
};

export function getVideoData(video_json: any[]): VideoListData[] {
  return video_json?.map((item) => ({
    title: item?.title ?? "",
    url: item?.url ?? "",
    platform: item?.platform as "FILE" | "YOUTUBE",
    cate: item?.cate as VIDEO_TYPE[],
    type: MEDIA_TYPE.VIDEO,
  }));
}
